import { IoTrashOutline } from 'react-icons/io5';

import { BaseComponentProps } from '../../../../types/base-component.types';
import { ConfirmStepButton } from './ConfirmStepButton';

type ContainerProps = BaseComponentProps & {
  title: string;
  subtitle?: string;
  disabled?: boolean;
  isDeleting: boolean;
  onDelete: () => void;
};

/** The bin every step footer carries: {@link ConfirmStepButton} in its one common shape. */
function DeleteStepButton({
  title,
  subtitle,
  disabled,
  isDeleting,
  onDelete,
  testId = 'delete-step-button',
}: ContainerProps) {
  return (
    <ConfirmStepButton
      icon={<IoTrashOutline />}
      tone="danger"
      title={title}
      subtitle={subtitle}
      confirmLabel="Eliminar"
      disabled={disabled}
      isPending={isDeleting}
      onConfirm={onDelete}
      testId={testId}
    />
  );
}

export { DeleteStepButton };
